<div class="terms-wrapper">
    <div class="terms-content">

        <markdown [src]="markdownPath"></markdown>

    </div>

</div>